import { action as apiAction } from 'api/Api'
import {
  setStatus as setCardStatus
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'
import sweetalert from 'sweetalert2'

type Payload = {
  id: number
  statusId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { id, statusId } = payload

  const optimisticAction = optimisticDispatch(dispatch, setCardStatus({
    id,
    statusId
  }))

  try {
    await apiAction('SetCardStatus', {
      cardId: id,
      cardStatusId: statusId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code === 539) { // Card is blocked
      try {
        await sweetalert({
          text: getState().kanbo.locale.messages['BLOCKERS_CARD_BLOCKED_ERROR'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
